import React, { Component } from 'react';
import { NavLink } from 'reactstrap';
import Swal from 'sweetalert2';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import { SelectBox } from 'devextreme-react/select-box';
import ReactTooltip from "react-tooltip"; //npm install react - tooltip
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import { getRequestParams } from '../../helpers/globalfunctions.js';
import { ParentAccount, ModuleCode, CustomerType, ApplicationType } from '../../helpers/fixcodes.js';
import { Country } from '../../datastore/country.json';
import { StateData } from '../../datastore/state.json';
import { City } from '../../datastore/city.json';
import jsSHA from "jssha"; // npm install jssha

/* global $ */
const google = window.google;
window.ngaccount = this;

export class AccountRegistrationComponent extends Component {
    static displayName = AccountRegistrationComponent.name;
    constructor(props) {
        super(props);
        const queryString = require('query-string');
        const parsed = queryString.parse(this.props.location.search);
        const plan = parsed.plan;
        const transaction = parsed.transaction;
        const newaccountid = parsed.accountId;
        this.autocomplete = null;

        this.state = {
            newaccountid: newaccountid,
            transporterName: '',
            firstName: '',
            lastName: '',
            mobileNumber: '',
            phoneNumber: '',
            emailAddress: '',
            EINNumber: '',
            streetAddress: '',
            countryList: Country,
            country: '',
            stateList: [],
            stateName: '',
            cityList: [],
            city: '',
            zipcode: '',
            faxNumber: '',
            websiteURL: '',
            userPhone: '',
            userName: '',
            userEmailAddress: '',
            userPassword: '',
            confirmPassword: '',
            creditcardUserName: '',
            creditcardNumber: '',
            creditcardCVV: '',
            cardExpiry: "",
            isSubmited: false,
            message: '',
            selectedPlan: [],
            planFeatures: [],
            planId: plan,
            cardNumber: '',
            expiry: '',
            cvc: '',
            cardTypeName: '',
            cardImage: 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTc2IDM3NyIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5wbGFjZWhvbGRlcjwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9InBsYWNlaG9sZGVyIj4gICAgICAgICAgICA8cGF0aCBkPSJNNTI3LjkzMzc5MywzNzYuOTk4MjggTDQ4LjA2NjIwNjksMzc2Ljk5ODI4IEMzNS40MjM0ODAzLDM3Ny4xMDM5NjggMjMuMjU2NTg2NCwzNzIuMTg3ODkgMTQuMjQyMzI4MSwzNjMuMzMxNjE4IEM1LjIyODA2OTc1LDM1NC40NzUzNDYgMC4xMDQ5MTcxMDIsMzQyLjQwNDQwNyAwLDMyOS43NzQ0OTQgTDAsNDcuMjI1NDU1NCBDMC4xMDQ5MTcxMDIsMzQuNTk1NTQyNSA1LjIyODA2OTc1LDIyLjUyNDYwNCAxNC4yNDIzMjgxLDEzLjY2ODMzMTkgQzIzLjI1NjU4NjQsNC44MTIwNTk4NSAzNS40MjM0ODAzLC0wLjEwNDAxODI5NiA0OC4wNjYyMDY5LDAuMDAxNjY5NDg2NDYgTDUyNy45MzM3OTMsMC4wMDE2Njk0ODY0NiBDNTQwLjU3NjUyLC0wLjEwNDAxODI5NiA1NTIuNzQzNDE0LDQuODEyMDU5ODUgNTYxLjc1NzY3MiwxMy42NjgzMzE5IEM1NzAuNzcxOTMsMjIuNTI0NjA0IDU3NS44OTUwODMsMzQuNTk1NTQyNSA1NzYsNDcuMjI1NDU1NCBMNTc2LDMyOS45NzI5MTMgQzU3NS42NzI3ODYsMzU2LjE5NTY2MyA1NTQuMTg0MjczLDM3Ny4yMTg4NTcgNTI3LjkzMzc5MywzNzYuOTk4MjggWiIgaWQ9InNoYXBlIiBmaWxsPSIjRThFQkVFIiBmaWxsLXJ1bGU9Im5vbnplcm8iPjwvcGF0aD4gICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiBzdHJva2U9IiM3NTc1NzUiIHN0cm9rZS13aWR0aD0iMjAiIHg9IjQxOCIgeT0iNTgiIHdpZHRoPSI5MSIgaGVpZ2h0PSI2MyIgcng9IjMwIj48L3JlY3Q+ICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0yIiBmaWxsPSIjNzU3NTc1IiB4PSI1MyIgeT0iMjA4IiB3aWR0aD0iMTA3IiBoZWlnaHQ9IjQwIiByeD0iOCI+PC9yZWN0PiAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMiIgZmlsbD0iIzc1NzU3NSIgeD0iNDEzIiB5PSIyMDgiIHdpZHRoPSIxMDciIGhlaWdodD0iNDAiIHJ4PSI4Ij48L3JlY3Q+ICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0yIiBmaWxsPSIjNzU3NTc1IiB4PSIyOTMiIHk9IjIwOCIgd2lkdGg9IjEwNyIgaGVpZ2h0PSI0MCIgcng9IjgiPjwvcmVjdD4gICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTIiIGZpbGw9IiM3NTc1NzUiIHg9IjE3MyIgeT0iMjA4IiB3aWR0aD0iMTA3IiBoZWlnaHQ9IjQwIiByeD0iOCI+PC9yZWN0PiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+',
            transactionId: transaction,
            appTypeId: parseInt(ApplicationType.UTPro),
            vIsPasswordComplexity: false,
            vMinLength: 0,
            vMinUpperCaseLetter: 0,
            vMinLowerCaseLetter: 0,
            vMinNumber: 0,
            vMinSpecialCharacter: 0,
            errors: {
                transporterName: '',
                firstName: '',
                lastName: '',
                mobileNumber: '',
                phoneNumber: '',
                emailAddress: '',
                EINNumber: '',
                streetAddress: '',
                city: '',
                stateName: '',
                country: '',
                zipcode: '',
                faxNumber: '',
                websiteURL: '',
                userPhone: '',
                userName: '',
                userEmailAddress: '',
                userPassword: '',
                confirmPassword: '',
                creditcardUserName: '',
                creditcardNumber: '',
                creditcardCVV: '',
                cardExpiry: "",
            },
        };

        this.getPlanDetails = this.getPlanDetails.bind(this);
        this.getValidationRules = this.getValidationRules.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleStateChange = this.handleStateChange.bind(this);
        this.handleCityChange = this.handleCityChange.bind(this);

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
        this.cardExpiry = this.cardExpiry.bind(this);
        this.limitMonthCreditCard = this.limitMonthCreditCard.bind(this);
        this.limitYearCreditCard = this.limitYearCreditCard.bind(this);

        // Registration Successful message on page default — commented out
        // const isTransactionSuccess = true;
        // let transactionSuccessmesage = "";
        // transactionSuccessmesage = "Thank you for getting in touch! <br><br>";
        // transactionSuccessmesage += "\tWe appreciate you for joining our platform. One of our customer happiness members will be getting back to you within a few hours.<br>";
        // transactionSuccessmesage += "<br> In the meantime, you can check out the following things:";
        //transactionSuccessmesage += "<br> 1) Verify the email address link sent to you, waiting for your attention.";
        // transactionSuccessmesage += "<br> 1) Setup your account.";
        // transactionSuccessmesage += "<br> 2) Go through Step - by - Step Tutorials";
        // if (this.state.transactionId !== null) {
        // Swal.fire({
        // icon: isTransactionSuccess ? 'success' : 'error',
        // title: isTransactionSuccess ? 'Registration Successful' : 'Oops...',
                //text: data.resultMessage,
        // width: '850px',
        // html: transactionSuccessmesage,
        // showCloseButton: true,
        // showCancelButton: true,
        // focusConfirm: false,
        // confirmButtonText: '<i class="fa fa-thumbs-up"></i> Great!',
        // confirmButtonAriaLabel: 'Thumbs up, great!',
        // cancelButtonText: '<i class="fa fa-thumbs-down"></i>',
        // cancelButtonAriaLabel: 'Thumbs down'
        // }).then((result) => {
        // /* Read more about isConfirmed, isDenied below */
        // if (isTransactionSuccess) {
        // if (result.isConfirmed) { 
        // window.location.href = './accountsetup?ngid=' + parseInt(this.state.newaccountid);
                        //if (parseInt(data.retValue) > 0) {
                        //    window.location.href = './accountsetup?ngid=' + parseInt(data.retValue);
                        //}
                        //else {
                        //    this.setState({ isSubmited: false });
                        //}
        // }
        // else {
        // this.setState({ isSubmited: false });
        // }
        // } else {
        // this.setState({ isSubmited: false });
        // }
        // });
        // }
    };

    componentDidMount() {
        if (this.state.transactionId === null) {
            this.getPlanDetails();
            this.getValidationRules();
        }
    };

    async getValidationRules() {
        try {
            const account = 0;
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('plan-api/validation-rule/' + account + '/' + parseInt(this.state.appTypeId), requestParams);
            const data = await response.json();
            if (data !== null && data.passwordValidationRule !== null) {
                this.setState({
                    vIsPasswordComplexity: data.passwordValidationRule.isPasswordComplexity,
                    vMinLength: data.passwordValidationRule.minLength,
                    vMinUpperCaseLetter: data.passwordValidationRule.minUpperCaseLetter,
                    vMinLowerCaseLetter: data.passwordValidationRule.minLowerCaseLetter,
                    vMinNumber: data.passwordValidationRule.minNumber,
                    vMinSpecialCharacter: data.passwordValidationRule.minSpecialCharacter
                });
            }
        } catch (e) {
            // validation rules unavailable — use defaults
        }
    }

    async getPlanDetails() {
        const newObject = {
            PlanId: Number(this.state.planId),
            PlanFeatureId: 0,
        };

        const requestParams = {
            method: 'post',
            headers: {
                'content-type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('session_token')
            },
            body: JSON.stringify(newObject)
        }

        const response = await fetch('plan-api/plan', requestParams);
        const data = await response.json();

        this.setState({
            selectedPlan: data.plans[0],
            planFeatures: data.planFeatures,
        });
    };

    handlePlaceSelect() {
        if (this.autocomplete !== null) {            
            let place = this.autocomplete.getPlace();
            let address = place.address_components;
            let placedetails = place.formatted_address.trim();

            if (place.formatted_address.trim() !== "") {
                let splitAddress = [];
                splitAddress = place.formatted_address.split(',');
                if (splitAddress.length > 0) {
                    if (splitAddress.length === 1) {
                        this.setState({
                            streetAddress: place.name,
                            //city: "",                            
                            //state: "",
                            //country: "",
                            zipcode: "",
                        });
                    }
                    else if (splitAddress.length === 2) {
                        this.setState({
                            streetAddress: place.name,
                            //city: splitAddress[0],
                            //state: splitAddress[1].trim().search(' ') > 0 ? splitAddress[1].trim().split(' ')[0] : "0",                            
                            //country: splitAddress[3].trim(),
                            zipcode: splitAddress[1].trim().search(' ') > 0 ? splitAddress[1].trim().split(' ')[1] : "0",
                        });
                    }
                    else if (splitAddress.length === 3) {
                        this.setState({
                            streetAddress: place.name,
                            //city: splitAddress[0].trim(),
                            //state: splitAddress[1].trim().search(' ') > 0 ? splitAddress[1].trim().split(' ')[0] : "0",                            
                            //country: splitAddress[2].trim(),
                            zipcode: splitAddress[1].trim().search(' ') > 0 ? splitAddress[1].trim().split(' ')[1] : "0",
                        });
                    }
                    else if (splitAddress.length === 4) {
                        this.setState({
                            streetAddress: place.name,
                            //city: splitAddress[1].trim(),
                            //state: splitAddress[2].trim().search(' ') > 0 ? splitAddress[2].trim().split(' ')[0] : "0",                            
                            //country: splitAddress[3].trim(),
                            zipcode: splitAddress[2].trim().search(' ') > 0 ? splitAddress[2].trim().split(' ')[1] : "0",
                        });
                    }
                    else if (splitAddress.length === 5) {
                        this.setState({
                            streetAddress: place.name,
                            //city: splitAddress[2].trim(),
                            //state: splitAddress[3].trim().search(' ') > 0 ? splitAddress[3].trim().split(' ')[0] : "0",                            
                            //country: splitAddress[3].trim(),
                            zipcode: splitAddress[3].trim().search(' ') > 0 ? splitAddress[3].trim().split(' ')[1] : "0",
                        });
                    }
                    else if (splitAddress.length === 6) {
                        this.setState({
                            streetAddress: place.name,
                            //city: splitAddress[3].trim(),
                            //state: splitAddress[4].trim().search(' ') > 0 ? splitAddress[4].trim().split(' ')[0] : "0",                            
                            //country: splitAddress[3].trim(),
                            zipcode: splitAddress[4].trim().search(' ') > 0 ? splitAddress[4].trim().split(' ')[1] : "0",
                        });
                    }
                    else {
                        this.setState({
                            streetAddress: place.name,
                            //city: splitAddress[4].trim(),
                            //state: splitAddress[5].trim().search(' ') > 0 ? splitAddress[5].trim().split(' ')[0] : "0",                            
                            //country: splitAddress[3].trim(),
                            zipcode: splitAddress[5].trim().search(' ') > 0 ? splitAddress[5].trim().split(' ')[1] : "0",
                        });

                    }
                }
                else {
                    this.setState({
                        streetAddress: "",
                        //city: "",
                        //state: "",                        
                        //country: "",
                        zipcode: "",
                    });
                }

                if (this.state.zipcode !== "") {
                    this.setState(prevState => ({ errors: { ...prevState.errors, zipcode: "" } }));
                }
                window.servicelocation = this.state.city;
            }
        }
    }

    handleValidation() {
        const errors = { ...this.state.errors };
        let formIsValid = true;
        //return true;
        errors.transporterName = "";
        errors.firstName = "";
        errors.lastName = "";
        errors.phoneNumber = "";
        errors.mobileNumber = "";
        errors.emailAddress = "";
        errors.EINNumber = "";
        errors.streetAddress = "";
        errors.city = "";
        errors.stateName = "";
        errors.country = "";
        errors.zipcode = "";
        errors.faxNumber = "";
        errors.websiteURL = "";
        errors.userPhone = "";
        errors.userName = "";
        errors.userEmailAddress = "";
        errors.userPassword = "";
        errors.confirmPassword = "";
        errors.creditcardUserName = "";
        errors.creditcardNumber = "";
        errors.creditcardCVV = "";
        errors.cardExpiry = "";

        this.setState({ message: '' });

        if (this.state.transporterName === '') {
            formIsValid = false;
            errors.transporterName = "Please enter transporter name";
        }

        if (this.state.firstName === '') {
            formIsValid = false;
            errors.firstName = "Please enter first name";
        }

        if (this.state.lastName === '') {
            formIsValid = false;
            errors.lastName = "Please enter last name";
        }

        if (this.state.phoneNumber.trim() === '') {
            formIsValid = false;
            errors.phoneNumber = "Please enter phone number";
        } else if (this.state.phoneNumber.trim().replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length !== 10) {
            formIsValid = false;
            errors.phoneNumber = "Invalid phone number";
        }

        if (this.state.mobileNumber.trim() === '') {
            formIsValid = false;
            errors.mobileNumber = "Please enter mobile number";
        } else if (this.state.mobileNumber.trim().replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length !== 10) {
            formIsValid = false;
            errors.mobileNumber = "Invalid mobile number";
        }

        if (this.state.emailAddress === '') {
            formIsValid = false;
            errors.emailAddress = "Please enter email address";
        }

        if (this.state.emailAddress !== '') {
            let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!regEmail.test(this.state.emailAddress)) {
                formIsValid = false;
                errors.emailAddress = "Please enter valid email";
            }
        }

        if (this.state.EINNumber === '') {
            formIsValid = false;
            errors.EINNumber = "Please enter EIN/registration number";
        }

        if (this.state.streetAddress === '') {
            formIsValid = false;
            errors.streetAddress = "Please enter street address";
        }

        if (this.state.city === '') {
            formIsValid = false;
            errors.city = "Please enter city";
        }

        if (this.state.stateName === '') {
            formIsValid = false;
            errors.stateName = "Please enter state";
        }

        if (this.state.country === '') {
            formIsValid = false;
            errors.country = "Please enter country";
        }

        if (this.state.zipcode === '') {
            formIsValid = false;
            errors.zipcode = "Please enter zip code";
        }
        else if (this.state.zipcode.length <= 4) {
            formIsValid = false;
            errors.zipcode = "Minimum length of zip code should be 5";
        }

        if (this.state.userPhone.trim() === '') {
            formIsValid = false;
            errors.userPhone = "Please enter phone number";
        } else if (this.state.userPhone.trim().replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length !== 10) {
            formIsValid = false;
            errors.userPhone = "Invaid user phone number";
        }

        if (this.state.userName === '') {
            formIsValid = false;
            errors.userName = "Please enter username";
        }

        const renumbersymbolexp = /[^0-9]/g;
        const lowercaseexp = /[^a-z]/g;
        const uppercaseexp = /[^A-Z]/g;
        const specialcharacters = /[^!@#$%^&*]/g;

        if (this.state.userPassword.trim() === '') {
            formIsValid = false;
            errors.userPassword = "Please enter password";
        }
        if (this.state.userPassword.trim() !== '' && this.state.vIsPasswordComplexity === true) {
            let IsPwdnumbersymbol = this.state.userPassword.replace(renumbersymbolexp, "").length;
            let IsLowercase = this.state.userPassword.replace(lowercaseexp, "").length;
            let IsUppercase = this.state.userPassword.replace(uppercaseexp, "").length;
            let IsSpecialCharacters = this.state.userPassword.replace(specialcharacters, "").length;

            if (this.state.userPassword.length < this.state.vMinLength) {
                formIsValid = false;
                errors.userPassword = "Password must be " + this.state.vMinLength + " characters long";
            }
            else if (IsPwdnumbersymbol < this.state.vMinNumber) {
                formIsValid = false;
                errors.userPassword = "Password must contains atleast " + this.state.vMinNumber + " number";
            }
            else if (IsLowercase < this.state.vMinLowerCaseLetter) {
                formIsValid = false;
                errors.userPassword = "Password must contains atleast " + this.state.vMinLowerCaseLetter + " lowercase alphabet";
            }
            else if (IsUppercase < this.state.vMinUpperCaseLetter) {
                formIsValid = false;
                errors.userPassword = "Password must contains atleast " + this.state.vMinUpperCaseLetter + " uppercase alphabet";
            }
            else if (IsSpecialCharacters < this.state.vMinSpecialCharacter) {
                formIsValid = false;
                errors.userPassword = "Password must contains atleast " + this.state.vMinSpecialCharacter + " special character";
            }
        }

        if (this.state.confirmPassword === '') {
            formIsValid = false;
            errors.confirmPassword = "Please enter confirm password";
        } else if (this.state.userPassword !== this.state.confirmPassword) {
            formIsValid = false;
            errors.userPassword = "Password does not match";
        }

        //if (this.state.creditcardUserName == '') {
        //    formIsValid = false;
        //    errors.creditcardUserName = "Please enter name on credit card";
        //}

        //if (this.state.creditcardNumber == '') {
        //    formIsValid = false;
        //    errors.creditcardNumber = "Please enter credit card number";
        //} else if (this.state.creditcardNumber.trim().replace(" ", "").length <= 16) {
        //    formIsValid = false;
        //    errors.creditcardNumber = "Invaid credit card number";
        //}

        //if (this.state.cardExpiry === "" || this.state.cardExpiry == undefined) {
        //    formIsValid = false;
        //    errors.cardExpiry = "Please enter card expiry";
        //}

        //if (this.state.creditcardCVV == '') {
        //    formIsValid = false;
        //    errors.creditcardCVV = "Please enter credit card CVV";
        //}
        //else {
        //    if (this.state.cardTypeName == "amex") {
        //        if (this.state.creditcardCVV.length != 4) {
        //            formIsValid = false;
        //            errors.creditcardCVV = "CVV number should be 4 digit";
        //        }
        //    }
        //    else {
        //        if (this.state.creditcardCVV.length != 3) {
        //            formIsValid = false;
        //            errors.creditcardCVV = "CVV number should be 3 digit";
        //        }
        //    }
        //}

        this.setState({ errors: errors });
        return formIsValid;
    }

    clearControl() {
        this.setState({
            ngaccid: 0,
            transporterName: '',
            firstName: '',
            lastName: '',
            phoneNumber: '',
            mobileNumber: '',
            emailAddress: '',
            EINNumber: '',
            streetAddress: '',
            city: '',
            stateName: '',
            country: '',
            zipcode: '',
            faxNumber: '',
            websiteURL: '',
            userPhone: '',
            userName: '',
            userEmailAddress: '',
            password: '',
            confirmPassword: '',
            creditcardUserName: '',
            creditcardNumber: '',
            creditcardCVV: '',
            cardExpiry: '',
            isSubmited: false,
            message: '',
            newaccountid: '',
            transactionId: '',
            vIsPasswordComplexity: false,
            vMinLength: 0,
            vMinUpperCaseLetter: 0,
            vMinLowerCaseLetter: 0,
            vMinNumber: 0,
            vMinSpecialCharacter: 0,
            errors: {
                transporterName: '',
                firstName: '',
                lastName: '',
                phoneNumber: '',
                mobileNumber: '',
                emailAddress: '',
                EINNumber: '',
                streetAddress: '',
                city: '',
                stateName: '',
                country: '',
                zipcode: '',
                faxNumber: '',
                websiteURL: '',
                userPhone: '',
                userName: '',
                userEmailAddress: '',
                password: '',
                confirmPassword: '',
                creditcardUserName: '',
                creditcardNumber: '',
                creditcardCVV: '',
                cardExpiry: '',
            }
        });
    }

    handleCountryChange(selectedValue) {
        this.setState({ country: '', streetAddress: '', zipcode: '' });
        if (selectedValue.selectedItem !== null) {

            let stetelet = [];
            this.setState({ country: (selectedValue.selectedItem !== null ? selectedValue.selectedItem.countryName : ''), });
            for (let a = 0; a < StateData.length; a++) {
                if (StateData[a].countryId === selectedValue.selectedItem.countryId) {
                    stetelet.push(StateData[a]);
                }
            }

            this.setState(prevState => ({ stateList: stetelet, stateName: '', errors: { ...prevState.errors, country: "" } }));

            //switch (selectedValue.selectedItem.countryId) {
            //    case 1:
            //    case 104:
                    const cityoptions = { types: ['establishment'] };
                    this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('streetAddress'), cityoptions)
                    this.autocomplete.addListener("place_changed", this.handlePlaceSelect)
                    //break;
            //    default:
            //        break;
            //}
            //if (selectedValue.selectedItem.countryId == 1) {
                
            //}
        }
        else {
            this.setState({ stateList: [], stateName: '', cityList: [], city: '' });
        }
    }

    handleStateChange(selectedValue) {
        this.setState({ stateName: (selectedValue.selectedItem !== null ? selectedValue.selectedItem.stateName : ''), });
        if (selectedValue.selectedItem !== null) {
            let citylet = [];
            for (let a = 0; a < City.length; a++) {
                if (City[a].stateId === selectedValue.selectedItem.stateId) {
                    citylet.push(City[a]);
                }
            }
            this.setState(prevState => ({ cityList: citylet, errors: { ...prevState.errors, stateName: "" } }));
        }
        else {
            this.setState({ stateName: '', cityList: [], city: '' });
        }
    }

    handleCityChange(selectedValue) {
        this.setState(prevState => ({
            city: selectedValue.selectedItem !== null ? selectedValue.selectedItem.cityName : '',
            errors: { ...prevState.errors, city: "" },
        }));
    }

    async handleSubmit(e) {
        e.preventDefault();
        if (this.handleValidation()) {
            this.setState({ isSubmited: true });
            const RegisterRequest = {};
            RegisterRequest.Account = {};
            RegisterRequest.Account.ParentAccountId = ParentAccount.UTWIZ;
            RegisterRequest.Account.ModuleId = ModuleCode.SECURITYGUARDAGGREGATOR;
            RegisterRequest.Account.AccountCode = "";
            RegisterRequest.Account.AccountName = this.state.transporterName;
            RegisterRequest.Account.ContactPerson = this.state.firstName + " " + this.state.lastName;
            RegisterRequest.Account.WebAddress = this.state.websiteURL;
            RegisterRequest.Account.CityId = 0;
            RegisterRequest.Account.CityName = this.state.city;
            RegisterRequest.Account.StateName = this.state.stateName;
            RegisterRequest.Account.CountryName = this.state.country;
            RegisterRequest.Account.Mobile = this.state.mobileNumber;
            RegisterRequest.Account.PhoneNo = this.state.phoneNumber;
            RegisterRequest.Account.UserName = this.state.userName;
            RegisterRequest.Account.Password = this.state.userPassword;
            RegisterRequest.Account.FirstName = this.state.firstName;
            RegisterRequest.Account.LastName = this.state.lastName;
            RegisterRequest.Account.Email = this.state.emailAddress;
            RegisterRequest.Account.UserEmail = this.state.emailAddress;
            RegisterRequest.Account.UserMobile = this.state.mobileNumber;
            RegisterRequest.Account.LegalName = this.state.transporterName;
            RegisterRequest.Account.SiteName = "";
            RegisterRequest.Account.SiteUrl = "";
            RegisterRequest.Account.SiteCategoryType = 0;
            RegisterRequest.Account.AirlineId = 0;
            RegisterRequest.Account.Address1 = this.state.streetAddress;
            RegisterRequest.Account.Address2 = "";
            RegisterRequest.Account.ZipCode = this.state.zipcode;
            RegisterRequest.Account.PinNo = "";
            RegisterRequest.Account.Timezone = 0;
            RegisterRequest.Account.CurrencyId = 0;
            RegisterRequest.Account.NoOfYearInOperation = 0;
            RegisterRequest.Account.PassLastYear = 0;
            RegisterRequest.Account.NoOfPassengerToUsa = 0;
            RegisterRequest.Account.NoOfPassengerToRow = 0;
            RegisterRequest.Account.NoOfTerminal = 0;
            RegisterRequest.Account.PaymentMode = 0;
            RegisterRequest.Account.ConstitutionTypeId = 0;
            RegisterRequest.Account.IsActive = true;
            RegisterRequest.Account.IsServiceApiProvided = false;
            RegisterRequest.Account.TemplateTypeName = "ACCOUNT REGISTRATION";
            RegisterRequest.Account.NotificationSubject = "Affiliate Account Registered";
            RegisterRequest.Account.CustomerTypeId = CustomerType.Affiliates;
            RegisterRequest.Account.RateType = 0;
            RegisterRequest.Account.BillToCustomerId = 0;
            RegisterRequest.Account.ParentCustomerId = 0;
            RegisterRequest.Account.FaxNo = this.state.faxNumber;
            RegisterRequest.Account.CountryCode = "";
            RegisterRequest.Account.AreaCode = "";
            RegisterRequest.Account.SkinId = 0;
            RegisterRequest.Account.LogoSize = 0;
            RegisterRequest.Account.Logo = "";
            RegisterRequest.Account.LogoName = "";
            RegisterRequest.Account.LogoExt = "";
            RegisterRequest.Account.ReportDisplayName = "";
            RegisterRequest.Account.ReportHeader = "";
            RegisterRequest.Account.ReportFooter = "";
            RegisterRequest.Account.Notes = "";
            RegisterRequest.Account.SpecialInstruction = "";
            RegisterRequest.Account.ReportImage = "";
            RegisterRequest.Account.IsPriority = false;
            RegisterRequest.Account.Rating = 'N';
            RegisterRequest.Account.PlanId = parseInt(this.state.planId);
            RegisterRequest.Account.DefaultUserLocationId = 0;
            RegisterRequest.Account.RegistrationNumber = this.state.EINNumber;
            //Billing Setting
            RegisterRequest.BillingSetting = {};
            RegisterRequest.BillingSetting.AccountId = 0;
            RegisterRequest.BillingSetting.IsCreditLimit = false;
            RegisterRequest.BillingSetting.CreditLimitAmount = 1000;
            RegisterRequest.BillingSetting.CreditLimitUsedAmount = 0;
            RegisterRequest.BillingSetting.BillingTypeId = 0;
            RegisterRequest.BillingSetting.BillingCycleId = 0;
            RegisterRequest.BillingSetting.IsDiscountApplicable = false;
            RegisterRequest.BillingSetting.IsDiscountPercentage = false;
            RegisterRequest.BillingSetting.DiscountCharge = 0;
            RegisterRequest.BillingSetting.IsCommissionApplicable = false;
            RegisterRequest.BillingSetting.IsCommissionPercentage = false;
            RegisterRequest.BillingSetting.CommissionCharge = 0;
            RegisterRequest.BillingSetting.IsMarkupApplicable = false;
            RegisterRequest.BillingSetting.IsMarkupPercentage = false;
            RegisterRequest.BillingSetting.MarkupCharge = 0;
            RegisterRequest.BillingSetting.WefDate = new Date();
            //location
            RegisterRequest.Location = {};
            RegisterRequest.Location.AccountId = 0;
            RegisterRequest.Location.LocationId = 0;
            RegisterRequest.Location.IsActive = true;

            const locationEmails = [];
            RegisterRequest.LocationEmails = locationEmails;
            const requestParams = getRequestParams('POST', RegisterRequest);

            // ─── OLD CODE BACKUP (payment gateway flow) ──────────────────────────────
            // let successmesage = "Thank you for getting in touch! <br><br>";
            // successmesage += "\tWe appreciate you for joining our platform...<br>";
            // successmesage += "<br> 1) Setup your account.";
            // successmesage += "<br> 2) Go through Step - by - Step Tutorials";
            // try {
            //     const response = await fetch('/account-api/register', requestParams);
            //     const data = await response.json();
            //     let paymentskip = 1;
            //     if (data.isSuccess) {
            //         if (paymentskip) {
            //             const CreateTransactionRequest = {};
            //             CreateTransactionRequest.TransactionSource = "UtWiz Account Registration";
            //             CreateTransactionRequest.AccountId = parseInt(data.retValue);
            //             CreateTransactionRequest.Amount = parseFloat(parseFloat(this.state.selectedPlan.planCostPerMonth).toFixed(2));
            //             CreateTransactionRequest.PlanId = parseInt(this.state.planId);
            //             const transactionRequestParams = getRequestParams('POST', CreateTransactionRequest);
            //             const transactionResponse = await fetch('payment-gateway-api/' + data.paymentGatewayId + '/transaction', transactionRequestParams);
            //             const transactionData = await transactionResponse.json();
            //             if (transactionData.transactionId !== null && transactionData.settings.length >= 3) {
            //                 // ... build PayUMoney form and submit
            //                 $(postForm).appendTo('body').submit();
            //             } else { this.setState({ isSubmited: false }); }
            //         }
            //     }
            //     if (paymentskip) {
            //         Swal.fire({ icon: data.isSuccess ? 'success' : 'error', title: data.isSuccess ? 'Registration Successful' : 'Oops...', html: data.resultMessage, ... })
            //         .then((result) => {
            //             if (data.isSuccess && result.isConfirmed && parseInt(data.retValue) > 0) {
            //                 window.location.href = './accountsetup?ngid=' + parseInt(data.retValue);
            //             } else { this.setState({ isSubmited: false }); }
            //         });
            //     }
            // } catch (e) { this.setState({ isSubmited: false }); }
            // ─────────────────────────────────────────────────────────────────────────

            try {
                const response = await fetch('/account-api/register', requestParams);
                const data = await response.json();

                if (data.isSuccess) {
                    const accountId = parseInt(data.retValue);
                    if (accountId > 0) {
                        // Registration successful — redirect to account setup
                        window.location.href = './accountsetup?ngid=' + accountId;
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Account created but setup link is unavailable. Please contact support.',
                            allowOutsideClick: false,
                        });
                        this.setState({ isSubmited: false });
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Registration Failed',
                        text: data.resultMessage || 'Registration failed. Please try again.',
                        allowOutsideClick: false,
                    });
                    this.setState({ isSubmited: false });
                }
            } catch (e) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'An unexpected error occurred. Please try again.',
                    allowOutsideClick: false,
                });
                this.setState({ isSubmited: false });
            }
        }
    }

    handleInputChange(event) {
        const errors = { ...this.state.errors };
        const target = event.target;
        const name = target.name;

        if (name === "websiteURL") {
            this.setState({ websiteURL: event.target.value });
            const re = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
            if (event.target.value === "") {
                this.setState({ [name]: event.target.value });
                errors[name] = "";
            }
            else if (!re.test(event.target.value)) {
                errors.websiteURL = "Please enter valid Website URL";
            }
            else {
                this.setState({ [name]: event.target.value });
                errors[name] = "";
            }
        }
        else if (name === "faxNumber") {
            const re = /^[0-9\b]+$/;
            if (event.target.value === '' || re.test(event.target.value)) {
                this.setState({ faxNumber: event.target.value })
            }
        }
        else if (name === "zipcode") {
            const re = /^[0-9a-zA-Z]+$/;
            //const re = /[a-zA-Z0-9]/;
            if (event.target.value === '' || re.test(event.target.value)) {
                if (event.target.value.length <= 4) {
                    this.setState({ zipcode: event.target.value })
                    errors["zipcode"] = "Minimum length of zipcode should be 5";
                }
                else {
                    this.setState({ zipcode: event.target.value })
                    errors["zipcode"] = "";
                }
            }
            else {
                //this.setState({ [name]: event.target.value });
                errors["zipcode"] = "Please enter zip code";
            }
        }
        else if (name === "userPassword") {
            let pwd = event.target.value;
            this.setState({ userPassword: event.target.value });
            const renumbersymbolexp = /[^0-9]/g;
            const lowercaseexp = /[^a-z]/g;
            const uppercaseexp = /[^A-Z]/g;
            const specialcharacters = /[^!@#$%^&*]/g;

            let IsPwdnumbersymbol = pwd.replace(renumbersymbolexp, "").length;
            let IsLowercase = pwd.replace(lowercaseexp, "").length;
            let IsUppercase = pwd.replace(uppercaseexp, "").length;
            let IsSpecialCharacters = pwd.replace(specialcharacters, "").length;

            if (pwd === '') {
                errors.userPassword = "Please enter password";
            } else {
                errors[name] = "";
            }
            if (pwd !== '' && this.state.vIsPasswordComplexity === true) {
                if (IsLowercase < this.state.vMinLowerCaseLetter) {
                    errors.userPassword = "Password must contains atleast " + this.state.vMinLowerCaseLetter + " lowercase alphabet";
                }
                else if (IsUppercase < this.state.vMinUpperCaseLetter) {
                    errors.userPassword = "Password must contains atleast " + this.state.vMinUpperCaseLetter + " uppercase alphabet";
                }
                else if (IsPwdnumbersymbol < this.state.vMinNumber) {
                    errors.userPassword = "Password must contains atleast " + this.state.vMinNumber + " number";
                }
                else if (IsSpecialCharacters < this.state.vMinSpecialCharacter) {
                    errors.userPassword = "Password must contains atleast " + this.state.vMinSpecialCharacter + " special character";
                }
                else if (pwd.length < this.state.vMinLength) {
                    errors.userPassword = "Password must be " + this.state.vMinLength + " characters long";
                }
                else {
                    errors[name] = "";
                }
            }
        }
        else if (name === "confirmPassword") {
            let cnfpwd = event.target.value;
            this.setState({ confirmPassword: event.target.value });
            if (cnfpwd === '') {
                errors.confirmPassword = "Please enter confirm password";
            } else if (this.state.userPassword !== cnfpwd) {
                errors.confirmPassword = "Password does not match";
            }
            else {
                errors[name] = "";
            }
        }
        //else if (name === "creditcardNumber") {
        //    const re = /^[0-9\b]+$/;
        //    this.setState({ creditcardNumber: event.target.value });
        //    this.setState({ cardTypeName: "" });
        //    this.setState({ cardImage: "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTc2IDM3NyIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5wbGFjZWhvbGRlcjwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9InBsYWNlaG9sZGVyIj4gICAgICAgICAgICA8cGF0aCBkPSJNNTI3LjkzMzc5MywzNzYuOTk4MjggTDQ4LjA2NjIwNjksMzc2Ljk5ODI4IEMzNS40MjM0ODAzLDM3Ny4xMDM5NjggMjMuMjU2NTg2NCwzNzIuMTg3ODkgMTQuMjQyMzI4MSwzNjMuMzMxNjE4IEM1LjIyODA2OTc1LDM1NC40NzUzNDYgMC4xMDQ5MTcxMDIsMzQyLjQwNDQwNyAwLDMyOS43NzQ0OTQgTDAsNDcuMjI1NDU1NCBDMC4xMDQ5MTcxMDIsMzQuNTk1NTQyNSA1LjIyODA2OTc1LDIyLjUyNDYwNCAxNC4yNDIzMjgxLDEzLjY2ODMzMTkgQzIzLjI1NjU4NjQsNC44MTIwNTk4NSAzNS40MjM0ODAzLC0wLjEwNDAxODI5NiA0OC4wNjYyMDY5LDAuMDAxNjY5NDg2NDYgTDUyNy45MzM3OTMsMC4wMDE2Njk0ODY0NiBDNTQwLjU3NjUyLC0wLjEwNDAxODI5NiA1NTIuNzQzNDE0LDQuODEyMDU5ODUgNTYxLjc1NzY3MiwxMy42NjgzMzE5IEM1NzAuNzcxOTMsMjIuNTI0NjA0IDU3NS44OTUwODMsMzQuNTk1NTQyNSA1NzYsNDcuMjI1NDU1NCBMNTc2LDMyOS45NzI5MTMgQzU3NS42NzI3ODYsMzU2LjE5NTY2MyA1NTQuMTg0MjczLDM3Ny4yMTg4NTcgNTI3LjkzMzc5MywzNzYuOTk4MjggWiIgaWQ9InNoYXBlIiBmaWxsPSIjRThFQkVFIiBmaWxsLXJ1bGU9Im5vbnplcm8iPjwvcGF0aD4gICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiBzdHJva2U9IiM3NTc1NzUiIHN0cm9rZS13aWR0aD0iMjAiIHg9IjQxOCIgeT0iNTgiIHdpZHRoPSI5MSIgaGVpZ2h0PSI2MyIgcng9IjMwIj48L3JlY3Q+ICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0yIiBmaWxsPSIjNzU3NTc1IiB4PSI1MyIgeT0iMjA4IiB3aWR0aD0iMTA3IiBoZWlnaHQ9IjQwIiByeD0iOCI+PC9yZWN0PiAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMiIgZmlsbD0iIzc1NzU3NSIgeD0iNDEzIiB5PSIyMDgiIHdpZHRoPSIxMDciIGhlaWdodD0iNDAiIHJ4PSI4Ij48L3JlY3Q+ICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0yIiBmaWxsPSIjNzU3NTc1IiB4PSIyOTMiIHk9IjIwOCIgd2lkdGg9IjEwNyIgaGVpZ2h0PSI0MCIgcng9IjgiPjwvcmVjdD4gICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTIiIGZpbGw9IiM3NTc1NzUiIHg9IjE3MyIgeT0iMjA4IiB3aWR0aD0iMTA3IiBoZWlnaHQ9IjQwIiByeD0iOCI+PC9yZWN0PiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+" });

        //    CardTypes.forEach((item) => {
        //        if (event.target.value.trim().match(item.pattern)) {
        //            cardObject.push(item);
        //            this.setState({ cardTypeName: item.name });
        //            this.setState({ cardImage: item.image });
        //            this.state.errors[name] = "";
        //        }
        //    });

        //    if (cardObject.length > 0) {
        //        if (event.target.value.replace(/ /g, '').length == cardObject[0].valid_length) {
        //            errors[name] = "";
        //        }
        //        else {
        //            errors.creditcardNumber = "Credit card number should be " + cardObject[0].valid_length + " digits long";
        //        }
        //    }
        //    else if (event.target.value.replace(/ /g, '').length == 16) {
        //        errors[name] = "";
        //    }
        //    else {
        //        errors.creditcardNumber = "Credit card number should be 16 digits long";
        //    }
        //    this.setState({ errors: errors });
        //}
        //else if (name == "creditcardCVV") {
        //    const re = /^[0-9\b]+$/;
        //    this.setState({ creditcardCVV: event.target.value });

        //    if (cardType == "amex" && event.target.value.length < 4) {
        //        errors.creditcardCVV = "CVV number should minimum be 4 digit";
        //        this.setState({ errors: errors });
        //    }
        //    else if (event.target.value.length < 3) {
        //        errors.creditcardCVV = "CVV number should minimum be 3 digit";
        //        this.setState({ errors: errors });
        //    }
        //    else {
        //        this.state.errors[name] = "";
        //    }
        //}
        else {
            if (/\S/.test(event.target.value)) {
                this.setState({ [name]: event.target.value });
                errors[name] = "";
            }
            else {
                if (event.target.value.length === 0) {
                    this.setState({ [name]: event.target.value });
                    errors[name] = "";
                }
            }
        }
        this.setState({ errors });
    }

    limitYearCreditCard(val, min) {
        if (val.length === 1 && val[0] < min[0]) {
            val = '0' + val;
        }

        if (val.length === 2) {
            if (Number(val) === 0) {
                val = '01';

                //this can happen when user paste number
            } else if (val < min) {
                val = min;
            }
        }

        return val;
    }

    limitMonthCreditCard(val, max) {
        if (val.length === 1 && val[0] > max[0]) {
            val = '0' + val;
        }

        if (val.length === 2) {
            if (Number(val) === 0) {
                val = '01';

                //this can happen when user paste number
            } else if (val > max) {
                val = max;
            }
        }

        return val;
    }

    cardExpiry(val) {
        let month = this.limitMonthCreditCard(val.substring(0, 2), '12');
        let date = this.limitYearCreditCard(val.substring(2, 4), new Date().getFullYear().toString().substring(2, 4));
        let cardExpirydate = month + (date.length ? '/' + date : '');
        this.setState(prevState => ({ errors: { ...prevState.errors, cardExpiry: "" } }));
        return cardExpirydate;

        //let month = this.limit(val.substring(0, 2), '12');
        //let year = val.substring(2, 4);
        //return month + (year.length ? '/' + year : '');
    }

    render() {
        document.querySelector('body').classList.remove('layout-top-nav');
        document.querySelector('body').classList.remove('login-page');
        return (
            <div className="register-page">
                <div className="container">
                    <form method="post" onSubmit={this.handleSubmit} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                        <div className="row">
                            {false && /* Left side container — commented out */
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                <div className="card card-plan">
                                    <div className="register-logo">
                                        <span className="register-box-msg"><img src="../../dist/img/logo_white_utwiz.png" alt="UTWiz" /><br />Register a new membership</span>
                                    </div>

                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left">
                                                <h5 className="card-plan-type">{this.state.selectedPlan.planName} Plan <span className="text-success">${parseFloat(this.state.selectedPlan.planCostPerMonth).toFixed(2)} /mo</span> </h5>
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right"><h5 className="card-plan-type">Account setup fees <span className="text-success">${parseFloat(this.state.selectedPlan.accountSetupFees).toFixed(2)}</span></h5></div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12 form-group">
                                                <div className="text-sm">
                                                    {this.state.planFeatures && this.state.planFeatures.map((fitem, i) => (
                                                        <p key={i}><i className="fas fa-check-circle"></i> {fitem.featureName}</p>
                                                    ))}
                                                    {/*<p><i className="fas fa-check-circle"></i> Unlimited Users</p>
                                                    <p><i className="fas fa-check-circle"></i> Reservation Management</p>
                                                    <p><i className="fas fa-check-circle"></i> Reporting</p>
                                                    <p><i className="fas fa-check-circle"></i> Driver &amp; Customer Mobile App</p>
                                                    <p><i className="fas fa-check-circle"></i> Unlimited Drivers</p>
                                                    <p><i className="fas fa-check-circle"></i> Dispatch Management</p>
                                                    <p><i className="fas fa-check-circle"></i> PCI Certified Platform</p>
                                                    <p><i className="fas fa-check-circle"></i> Scheduled Texting</p>
                                                    <p><i className="fas fa-check-circle"></i> Unlimited 24/7 Support</p>
                                                    <p><i className="fas fa-check-circle"></i> Flight Tracking</p>
                                                    <p><i className="fas fa-check-circle"></i> Driver Tracking</p>
                                                    <p><i className="fas fa-check-circle"></i> Scheduled Emailing</p>
                                                    <p><i className="fas fa-check-circle"></i> Unlimited Updates</p>
                                                    <p><i className="fas fa-check-circle"></i> Accounting</p>
                                                    <p><i className="fas fa-check-circle"></i> Online Booking Tools</p>
                                                    <p><i className="fas fa-check-circle"></i> Affiliate Networking Solutions</p>*/}
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <NavLink tag={Link} to="/plan" className="btn btn-block btn-secondary btn-sm" title="Change plan">Change Plan</NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div className="card card-registration">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12"><h5>Company Information</h5></div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label>Transporter Name <span className="text-danger">*</span></label>
                                                    <input type="text" className="form-control form-control-sm" name="transporterName" maxLength="50" value={this.state.transporterName} onChange={this.handleInputChange} placeholder="Enter transporter name" />
                                                    {this.state.errors["transporterName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["transporterName"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="">EIN/Registration Number <span className="text-danger">*</span></label>
                                                    <input type="text" className="form-control form-control-sm" name="EINNumber" maxLength="20" value={this.state.EINNumber} onChange={this.handleInputChange} placeholder="Enter ein/registration number" />
                                                    {this.state.errors["EINNumber"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["EINNumber"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="">Website URL <i className="fas fa-info-circle text-info" data-tip data-for="websiteURLTooltip"></i></label>
                                                    <input type="text" className="form-control form-control-sm" name="websiteURL" maxLength="100" value={this.state.websiteURL} onChange={this.handleInputChange} placeholder="Enter website url" />
                                                    {this.state.errors["websiteURL"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["websiteURL"]}</span>}
                                                    <ReactTooltip id="websiteURLTooltip" place="top" effect="solid"> <ul>
                                                        <li>http://www.example.com</li>
                                                        <li>https://www.example.com</li>
                                                        <li>http://example.com</li>
                                                        <li>www.example.com</li>
                                                    </ul></ReactTooltip>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="">Country <span className="text-danger">*</span></label>
                                                    <SelectBox
                                                        dataSource={this.state.countryList.length > 0 ? this.state.countryList : []}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        placeholder="Select country"
                                                        name="countryId"
                                                        defaultValue={0}
                                                        value={this.state.country === '' ? 0 : this.state.countryList.find(opt => opt.countryName === this.state.country).countryId}
                                                        displayExpr='countryName'
                                                        valueExpr='countryId'
                                                        onSelectionChanged={this.handleCountryChange}
                                                        showClearButton={true}
                                                        disabled={false}
                                                        searchEnabled={true}
                                                    />
                                                    {this.state.errors["country"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["country"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="">State <span className="text-danger">*</span></label>
                                                    <SelectBox
                                                        dataSource={this.state.stateList.length > 0 ? this.state.stateList : []}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        placeholder="Select state"
                                                        name="stateId"
                                                        defaultValue={0}
                                                        value={this.state.stateName === '' ? 0 : this.state.stateList.find(opt => opt.stateName === this.state.stateName).stateId}
                                                        displayExpr='stateName'
                                                        valueExpr='stateId'
                                                        onSelectionChanged={this.handleStateChange}
                                                        showClearButton={true}
                                                        disabled={false}
                                                        searchEnabled={true}
                                                    />
                                                    {this.state.errors["stateName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["stateName"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="">City <span className="text-danger">*</span></label>
                                                    <SelectBox
                                                        dataSource={this.state.cityList.length > 0 ? this.state.cityList : []}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        placeholder="Select city"
                                                        name="cityId"
                                                        defaultValue={0}
                                                        value={this.state.city === '' ? 0 : this.state.cityList.find(opt => opt.cityName === this.state.city).cityId}
                                                        displayExpr='cityName'
                                                        valueExpr='cityId'
                                                        onSelectionChanged={this.handleCityChange}
                                                        showClearButton={true}
                                                        disabled={false}
                                                        searchEnabled={true}
                                                    />
                                                    {this.state.errors["city"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["city"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="">Street Address <span className="text-danger">*</span></label>
                                                    <input type="text" className="form-control form-control-sm" maxLength="100" id="streetAddress" name="streetAddress" value={this.state.streetAddress} onChange={this.handleInputChange} placeholder="Enter street address" />
                                                    {this.state.errors["streetAddress"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["streetAddress"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="">Zip Code <span className="text-danger">*</span></label>
                                                    <input type="text" className="form-control form-control-sm" name="zipcode" maxLength="6" value={this.state.zipcode} onChange={this.handleInputChange} placeholder="Enter zip code" />
                                                    {this.state.errors["zipcode"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["zipcode"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label>Phone Number <span className="text-danger">*</span></label>
                                                    <NumberFormat className="form-control form-control-sm" name="phoneNumber" title="Phone Number" value={this.state.phoneNumber} onChange={this.handleInputChange} format="(###) ###-####" placeholder="(000) 000-0000" />
                                                    {this.state.errors["phoneNumber"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["phoneNumber"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label>Mobile Number <span className="text-danger">*</span></label>
                                                    <NumberFormat className="form-control form-control-sm" name="mobileNumber" title="Mobile Number" value={this.state.mobileNumber} onChange={this.handleInputChange} format="(###) ###-####" placeholder="(000) 000-0000" />
                                                    {this.state.errors["mobileNumber"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["mobileNumber"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label>Fax Number</label>
                                                    <NumberFormat className="form-control form-control-sm" name="faxNumber" title="Fax Number" value={this.state.faxNumber} onChange={this.handleInputChange} format="(###) ###-####" placeholder="(000) 000-0000" />
                                                    {this.state.errors["faxNumber"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["faxNumber"]}</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12"><h5>Contact Information</h5></div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="">First Name <span className="text-danger">*</span></label>
                                                    <input type="text" className="form-control form-control-sm" name="firstName" maxLength="50" value={this.state.firstName} onChange={this.handleInputChange} placeholder="Enter first name" />
                                                    {this.state.errors["firstName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["firstName"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="">Last Name <span className="text-danger">*</span></label>
                                                    <input type="text" className="form-control form-control-sm" name="lastName" maxLength="50" value={this.state.lastName} onChange={this.handleInputChange} placeholder="Enter last name" />
                                                    {this.state.errors["lastName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["lastName"]}</span>}
                                                </div>
                                            </div>

                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="">Email Address <span className="text-danger">*</span></label>
                                                    <input type="text" className="form-control form-control-sm" name="emailAddress" maxLength="50" value={this.state.emailAddress} onChange={this.handleInputChange} placeholder="example@domain.com" />
                                                    {this.state.errors["emailAddress"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["emailAddress"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="">Phone Number <span className="text-danger">*</span></label>
                                                    <NumberFormat className="form-control form-control-sm" name="userPhone" title="Phone Number" value={this.state.userPhone} onChange={this.handleInputChange} format="(###) ###-####" placeholder="(000) 000-0000" />
                                                    {this.state.errors["userPhone"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["userPhone"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="">Username <span className="text-danger">*</span></label>
                                                    <input type="text" className="form-control form-control-sm" name="userName" maxLength="25" value={this.state.userName} onChange={this.handleInputChange} placeholder="Enter username" />
                                                    {this.state.errors["userName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["userName"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="">Password  <span className="text-danger">*</span><i className="fas fa-info-circle text-info" data-tip data-for="passwordTooltip"></i></label>
                                                    <input type="password" className="form-control form-control-sm" id="userPassword" name="userPassword" maxLength="25" value={this.state.userPassword} onChange={this.handleInputChange} placeholder="Enter password" />
                                                    {this.state.errors["userPassword"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["userPassword"]}</span>}
                                                    <ReactTooltip id="passwordTooltip" place="top" effect="solid">
                                                        <div className="form-group">
                                                            <ul>
                                                                <li>At least {this.state.vMinLength} characters long</li>
                                                                <li>At least {this.state.vMinLowerCaseLetter} lowercase character</li>
                                                                <li>At least {this.state.vMinUpperCaseLetter} uppercase character</li>
                                                                <li>At least {this.state.vMinNumber} number, symbol, or whitespace character</li>
                                                                <li>At least {this.state.vMinSpecialCharacter} special character</li>
                                                            </ul>
                                                        </div>
                                                    </ReactTooltip>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="form-group">
                                                    <label htmlFor="">Confirm Password <span className="text-danger">*</span></label>
                                                    <input type="password" className="form-control form-control-sm" id="confirmPassword" name="confirmPassword" maxLength="25" value={this.state.confirmPassword} onChange={this.handleInputChange} placeholder="Re-enter password" />
                                                    <div className="input-group-append">
                                                        {this.state.errors["confirmPassword"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["confirmPassword"]}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*
                                 <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Credit Card Information</h3>
                                    </div>
                                    <div className="card-body register-card-body">
                                        <div className="row">
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                <label>Name on Card</label>
                                                <div className="input-group mb-3">
                                                    <input type="text" className="form-control form-control-sm" name="creditcardUserName" maxLength="50" value={this.state.creditcardUserName} onChange={this.handleInputChange} />
                                                    <div className="input-group-append">
                                                        <div className="input-group-text">
                                                            <span className="fas fa-user"></span>
                                                        </div>
                                                    </div>
                                                    {this.state.errors["creditcardUserName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["creditcardUserName"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                                                <label>Credit Card Number</label>
                                                <div className="input-group mb-3">
                                                    <NumberFormat className="form-control form-control-sm" name="creditcardNumber" format="#### #### #### ####" value={this.state.creditcardNumber} onChange={this.handleInputChange} />
                                                    <div className="input-group-append">
                                                        <div className="input-group-text">
                                                            <img src={this.state.cardImage} width="20" />
                                                        </div>
                                                    </div>
                                                    {this.state.errors["creditcardNumber"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["creditcardNumber"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                <label>Card Expiry</label>
                                                <div className="input-group mb-3">
                                                    <NumberFormat className="form-control form-control-sm" name="cardExpiry" placeholder="MM/YY" format={this.cardExpiry} title="Credit Card Expiry" value={this.state.cardExpiry} onValueChange={(values) => { const { formattedValue, value } = values; this.setState({ cardExpiry: formattedValue }) }} />
                                                    <div className="input-group-append">
                                                        <div className="input-group-text">
                                                            <span className="fas fa-calendar-alt"></span>
                                                        </div>
                                                    </div>
                                                    {this.state.errors["cardExpiry"].length >= 5 && <span className='error invalid-feedback'>{this.state.errors["cardExpiry"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2">
                                                <label>CVV</label>
                                                <div className="input-group mb-3">
                                                    <input type="password" className="form-control form-control-sm" name="creditcardCVV" maxLength="4" value={this.state.creditcardCVV} onChange={this.handleInputChange} />
                                                    <div className="input-group-append">
                                                        <div className="input-group-text">
                                                            <span className="fas fa-envelope"></span>
                                                        </div>
                                                    </div>
                                                    {this.state.errors["creditcardCVV"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["creditcardCVV"]}</span>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                 */}
                                    <div className="card-footer">
                                        <div className="row">
                                            <div className="col-6"><a href="/login" className="text-sm" title="I already have a membership"><i className="fas fa-user"></i> I already have a membership</a></div>
                                            <div className="col-6 text-right">
                                                <button type="submit" className="btn btn-md btn-success btn-sm" title="Sign up"><i className="fas fa-sign-in-alt"></i> Sign up</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}